import classNames from "classnames";
import { twMerge } from "tailwind-merge";

import { useApprovalTimelineDrawer } from "src/zustand/approval-timeline-drawer";

//status: approved - rejected - current - pending

export const CApprovalTimeline = ({
  code,
  createdBy,
  createdDate,
  statusText,
  timelineData = [],
}) => {
  const { handleOpen } = useApprovalTimelineDrawer();
  return timelineData?.length > 0 ? (
    <>
      <div className="flex flex-row justify-start">
        <button
          className="outline-none font-medium text-sm text-blue-600"
          onClick={() =>
            handleOpen(code, createdBy, createdDate, timelineData, statusText)
          }
        >
          Xem chi tiết
        </button>
      </div>

      <div className="flex flex-row items-center gap-2 pt-8 h-32">
        {timelineData.map((item, index) => (
          <div
            key={item.role_name + index}
            className={twMerge(
              "relative flex justify-center w-16 h-0.5 py-1 rounded-xl bg-slate-300",
              item.status === "approved" && "!bg-green-600",
              item.is_overdue && "!bg-red-600",
              item.status === "rejected" && "!bg-amber-600",
            )}
          >
            <span className="absolute bottom-3 text-[13px] font-medium !font-inter tracking-wide">
              {item.role_name}
            </span>
            <span className="absolute top-3 !font-inter">{item.hours}h</span>
          </div>
        ))}
      </div>
    </>
  ) : (
    <></>
  );
};
